import type { MixedItemTag } from "@memorang/types";
import { itemsCount, mockedDiagnosticStats } from "./common";

import type { DemoExamsType } from "../demo";

export const mockedTags = {
	proethica: [
		{
			id: 7501,
			label: "Module 1",
			type: "Module",
			weight: 0,
			icon: "school-outline",
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 10,
			numIncorrect: 0,
			numSkipped: 0,
			numPointsEarned: 10,
			numTotalPoints: 10,
			items: [],
			numItems: 10,
			averageScore: 92,
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 1,
				advanced: 9,
				none: 0,
			},
		},
		{
			id: 7502,
			label: "Module 2",
			type: "Module",
			weight: 0,
			icon: "school-outline",
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 12,
			numIncorrect: 0,
			numSkipped: 0,
			numPointsEarned: 12,
			numTotalPoints: 12,
			items: [],
			numItems: 12,
			averageScore: 88,
			distribution: {
				basic: 0,
				lowIntermediate: 1,
				highIntermediate: 1,
				advanced: 10,
				none: 0,
			},
		},
		{
			id: 7503,
			label: "Module 3",
			type: "Module",
			weight: 0,
			icon: "school-outline",
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 7,
			numIncorrect: 2,
			numSkipped: 1,
			numPointsEarned: 7,
			numTotalPoints: 9,
			items: [],
			numItems: 10,
			averageScore: 78,
			distribution: {
				basic: 2,
				lowIntermediate: 0,
				highIntermediate: 1,
				advanced: 7,
				none: 0,
			},
		},
		{
			id: 7504,
			label: "Module 4",
			type: "Module",
			weight: 0,
			icon: "school-outline",
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 4,
			numIncorrect: 1,
			numSkipped: 0,
			numPointsEarned: 4,
			numTotalPoints: 10,
			items: [],
			numItems: 10,
			averageScore: 42,
			distribution: {
				basic: 2,
				lowIntermediate: 2,
				highIntermediate: 0,
				advanced: 0,
				none: 6,
			},
		},
		{
			id: 7505,
			label: "Module 5",
			type: "Module",
			weight: 0,
			icon: "school-outline",
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 0,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 8,
			items: [],
			numItems: 8,
			averageScore: 0,
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 8,
			},
		},
		{
			id: 7506,
			label: "Module 6",
			type: "Module",
			weight: 0,
			icon: "school-outline",
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 0,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 10,
			items: [],
			numItems: 10,
			averageScore: 0,
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 10,
			},
		},
		{
			id: 7507,
			label: "Module 7",
			type: "Module",
			weight: 0,
			icon: "school-outline",
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 9,
			numIncorrect: 1,
			numSkipped: 0,
			numPointsEarned: 9,
			numTotalPoints: 10,
			items: [],
			numItems: 10,
			averageScore: 90,
			distribution: {
				basic: 0,
				lowIntermediate: 1,
				highIntermediate: 0,
				advanced: 9,
				none: 0,
			},
		},
		{
			id: 7508,
			label: "Module 8",
			type: "Module",
			weight: 0,
			icon: "school-outline",
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 0,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 1,
			items: [],
			numItems: 1,
			averageScore: 0,
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 1,
			},
		},
	],
	"healthcare-1": [
		{
			id: 6479,
			label: "Anatomy & Physiology",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 29,
			numIncorrect: 66,
			numSkipped: 0,
			numPointsEarned: 31,
			numTotalPoints: 101,
			items: [],
			numItems: itemsCount.Reading,
			averageScore: 30.42105263157895,
			distribution: {
				basic: 66,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 29,
				none: 45,
			},
		},
		{
			id: 6482,
			label: "Patient Care",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 11,
			numIncorrect: 18,
			numSkipped: 0,
			numPointsEarned: 11,
			numTotalPoints: 29,
			items: [],
			numItems: itemsCount.Listening,
			averageScore: 37.241379310344826,
			distribution: {
				basic: 18,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 11,
				none: 161,
			},
		},
		{
			id: 6481,
			label: "Medical Terminology",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 17,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 68,
			items: [],
			numItems: itemsCount.Speaking,
			averageScore: 0,
			distribution: {
				basic: 17,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 11,
			},
		},
		{
			id: 6480,
			label: "Healthcare Ethics",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 10,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 0,
			items: [],
			numItems: itemsCount.Writing,
			averageScore: 0.4,
			distribution: {
				basic: 10,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 4,
			},
		},
	],
	"construction-1": [
		{
			id: 6479,
			label: "Safety Regulations",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 29,
			numIncorrect: 66,
			numSkipped: 0,
			numPointsEarned: 31,
			numTotalPoints: 101,
			items: [],
			numItems: itemsCount.Reading,
			averageScore: 30.42105263157895,
			distribution: {
				basic: 66,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 29,
				none: 45,
			},
		},
		{
			id: 6482,
			label: "Building Codes",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 11,
			numIncorrect: 18,
			numSkipped: 0,
			numPointsEarned: 11,
			numTotalPoints: 29,
			items: [],
			numItems: itemsCount.Listening,
			averageScore: 37.241379310344826,
			distribution: {
				basic: 18,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 11,
				none: 161,
			},
		},
		{
			id: 6481,
			label: "Project Management",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 17,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 68,
			items: [],
			numItems: itemsCount.Speaking,
			averageScore: 0,
			distribution: {
				basic: 17,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 11,
			},
		},
		{
			id: 6480,
			label: "Construction Equipment",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 10,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 0,
			items: [],
			numItems: itemsCount.Writing,
			averageScore: 0.4,
			distribution: {
				basic: 10,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 4,
			},
		},
	],
	"finance-1": [
		{
			id: 6479,
			label: "Investment Analysis",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 29,
			numIncorrect: 66,
			numSkipped: 0,
			numPointsEarned: 31,
			numTotalPoints: 101,
			items: [],
			numItems: itemsCount.Reading,
			averageScore: 30.42105263157895,
			distribution: {
				basic: 66,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 29,
				none: 45,
			},
		},
		{
			id: 6482,
			label: "Risk Management",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 11,
			numIncorrect: 18,
			numSkipped: 0,
			numPointsEarned: 11,
			numTotalPoints: 29,
			items: [],
			numItems: itemsCount.Listening,
			averageScore: 37.241379310344826,
			distribution: {
				basic: 18,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 11,
				none: 161,
			},
		},
		{
			id: 6481,
			label: "Financial Markets",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 17,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 68,
			items: [],
			numItems: itemsCount.Speaking,
			averageScore: 0,
			distribution: {
				basic: 17,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 11,
			},
		},
		{
			id: 6480,
			label: "Portfolio Management",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 10,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 0,
			items: [],
			numItems: itemsCount.Writing,
			averageScore: 0.4,
			distribution: {
				basic: 10,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 4,
			},
		},
	],
	"officesync-1": [
		{
			id: 7001,
			label: "Crisis Communication",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 29,
			numIncorrect: 66,
			numSkipped: 0,
			numPointsEarned: 31,
			numTotalPoints: 101,
			items: [],
			numItems: itemsCount.Reading,
			averageScore: 30.42105263157895,
			distribution: {
				basic: 66,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 29,
				none: 45,
			},
		},
		{
			id: 7002,
			label: "Professional Listening",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 11,
			numIncorrect: 18,
			numSkipped: 0,
			numPointsEarned: 11,
			numTotalPoints: 29,
			items: [],
			numItems: itemsCount.Listening,
			averageScore: 37.241379310344826,
			distribution: {
				basic: 18,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 11,
				none: 161,
			},
		},
		{
			id: 7003,
			label: "Verbal Accountability",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 17,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 68,
			items: [],
			numItems: itemsCount.Speaking,
			averageScore: 0,
			distribution: {
				basic: 17,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 11,
			},
		},
		{
			id: 7004,
			label: "Workplace Writing",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 10,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 0,
			items: [],
			numItems: itemsCount.Writing,
			averageScore: 0.4,
			distribution: {
				basic: 10,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 4,
			},
		},
	],
	"techcore-1": [
		{
			id: 7101,
			label: "Incident Response",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 29,
			numIncorrect: 66,
			numSkipped: 0,
			numPointsEarned: 31,
			numTotalPoints: 101,
			items: [],
			numItems: itemsCount.Reading,
			averageScore: 30.42105263157895,
			distribution: {
				basic: 66,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 29,
				none: 45,
			},
		},
		{
			id: 7102,
			label: "Technical Listening",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 11,
			numIncorrect: 18,
			numSkipped: 0,
			numPointsEarned: 11,
			numTotalPoints: 29,
			items: [],
			numItems: itemsCount.Listening,
			averageScore: 37.241379310344826,
			distribution: {
				basic: 18,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 11,
				none: 161,
			},
		},
		{
			id: 7103,
			label: "Technical Speaking",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 17,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 68,
			items: [],
			numItems: itemsCount.Speaking,
			averageScore: 0,
			distribution: {
				basic: 17,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 11,
			},
		},
		{
			id: 7104,
			label: "IT Communication Writing",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 10,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 0,
			items: [],
			numItems: itemsCount.Writing,
			averageScore: 0.4,
			distribution: {
				basic: 10,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 4,
			},
		},
	],
	"mediquest-1": [
		{
			id: 7401,
			label: "History",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 29,
			numIncorrect: 66,
			numSkipped: 0,
			numPointsEarned: 31,
			numTotalPoints: 101,
			items: [],
			numItems: itemsCount.Reading,
			averageScore: 30.42105263157895,
			distribution: {
				basic: 66,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 29,
				none: 45,
			},
		},
		{
			id: 7402,
			label: "Exam",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 11,
			numIncorrect: 18,
			numSkipped: 0,
			numPointsEarned: 11,
			numTotalPoints: 29,
			items: [],
			numItems: itemsCount.Listening,
			averageScore: 37.241379310344826,
			distribution: {
				basic: 18,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 11,
				none: 161,
			},
		},
		{
			id: 7403,
			label: "Diagnosis",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 17,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 68,
			items: [],
			numItems: itemsCount.Speaking,
			averageScore: 0,
			distribution: {
				basic: 17,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 11,
			},
		},
		{
			id: 7404,
			label: "Management",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 10,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 0,
			items: [],
			numItems: itemsCount.Writing,
			averageScore: 0.4,
			distribution: {
				basic: 10,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 4,
			},
		},
	],
	"aswb-1": [
		{
			id: 7801,
			label: "Engagement",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 29,
			numIncorrect: 66,
			numSkipped: 0,
			numPointsEarned: 31,
			numTotalPoints: 101,
			items: [],
			numItems: itemsCount.Reading,
			averageScore: 30.42105263157895,
			distribution: {
				basic: 66,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 29,
				none: 45,
			},
		},
		{
			id: 7802,
			label: "Assessment",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 11,
			numIncorrect: 18,
			numSkipped: 0,
			numPointsEarned: 11,
			numTotalPoints: 29,
			items: [],
			numItems: itemsCount.Listening,
			averageScore: 37.241379310344826,
			distribution: {
				basic: 18,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 11,
				none: 161,
			},
		},
		{
			id: 7803,
			label: "Intervention",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 17,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 68,
			items: [],
			numItems: itemsCount.Speaking,
			averageScore: 0,
			distribution: {
				basic: 17,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 11,
			},
		},
		{
			id: 7804,
			label: "Advocacy",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 10,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 0,
			items: [],
			numItems: itemsCount.Writing,
			averageScore: 0.4,
			distribution: {
				basic: 10,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 4,
			},
		},
	],
	"aswb-supervision-certification": [
		{
			id: 7901,
			label: "Values and Ethics",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 29,
			numIncorrect: 66,
			numSkipped: 0,
			numPointsEarned: 31,
			numTotalPoints: 101,
			items: [],
			numItems: itemsCount.Reading,
			averageScore: 30.42105263157895,
			distribution: {
				basic: 66,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 29,
				none: 45,
			},
		},
		{
			id: 7902,
			label: "Assessment and Planning",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 11,
			numIncorrect: 18,
			numSkipped: 0,
			numPointsEarned: 11,
			numTotalPoints: 29,
			items: [],
			numItems: itemsCount.Listening,
			averageScore: 37.241379310344826,
			distribution: {
				basic: 18,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 11,
				none: 161,
			},
		},
		{
			id: 7903,
			label: "Intervention and Practice",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 17,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 68,
			items: [],
			numItems: itemsCount.Speaking,
			averageScore: 0,
			distribution: {
				basic: 17,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 11,
			},
		},
		{
			id: 7904,
			label: "Collaboration and Communication",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 10,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 0,
			items: [],
			numItems: itemsCount.Writing,
			averageScore: 0.4,
			distribution: {
				basic: 10,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 4,
			},
		},
	],
	"ai-assessment": [
		{
			id: 6490,
			label: "Reading",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 29,
			numIncorrect: 66,
			numSkipped: 0,
			numPointsEarned: 31,
			numTotalPoints: 101,
			items: [],
			numItems: itemsCount.Reading,
			averageScore: 30.42105263157895,
			distribution: {
				basic: 66,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 29,
				none: 45,
			},
		},
		{
			id: 6491,
			label: "Writing",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 11,
			numIncorrect: 18,
			numSkipped: 0,
			numPointsEarned: 11,
			numTotalPoints: 29,
			items: [],
			numItems: itemsCount.Writing,
			averageScore: 37.241379310344826,
			distribution: {
				basic: 18,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 11,
				none: 161,
			},
		},
		{
			id: 6492,
			label: "Speaking",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 17,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 68,
			items: [],
			numItems: itemsCount.Speaking,
			averageScore: 0,
			distribution: {
				basic: 17,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 11,
			},
		},
		{
			id: 6493,
			label: "Listening",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 10,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 0,
			items: [],
			numItems: itemsCount.Listening,
			averageScore: 0.4,
			distribution: {
				basic: 10,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 4,
			},
		},
	],
	"genai-engineer": [
		{
			id: 6479,
			label: "Reading",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 29,
			numIncorrect: 66,
			numSkipped: 0,
			numPointsEarned: 31,
			numTotalPoints: 101,
			items: [],
			numItems: itemsCount.Reading,
			averageScore: 30.42105263157895,
			distribution: {
				basic: 66,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 29,
				none: 45,
			},
		},
		{
			id: 6480,
			label: "Writing",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 11,
			numIncorrect: 18,
			numSkipped: 0,
			numPointsEarned: 11,
			numTotalPoints: 29,
			items: [],
			numItems: itemsCount.Writing,
			averageScore: 37.241379310344826,
			distribution: {
				basic: 18,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 11,
				none: 161,
			},
		},
		{
			id: 6481,
			label: "Speaking",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 17,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 68,
			items: [],
			numItems: itemsCount.Speaking,
			averageScore: 0,
			distribution: {
				basic: 17,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 11,
			},
		},
		{
			id: 6482,
			label: "Listening",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 10,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 0,
			items: [],
			numItems: itemsCount.Listening,
			averageScore: 0.4,
			distribution: {
				basic: 10,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 4,
			},
		},
	],
	"ai-essentials": [
		{
			id: 6483,
			label: "Prompt Engineering",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 29,
			numIncorrect: 66,
			numSkipped: 0,
			numPointsEarned: 31,
			numTotalPoints: 101,
			items: [],
			numItems: itemsCount.Reading,
			averageScore: 30.42105263157895,
			distribution: {
				basic: 66,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 29,
				none: 45,
			},
		},
		{
			id: 6484,
			label: "AI Hallucinations",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 11,
			numIncorrect: 18,
			numSkipped: 0,
			numPointsEarned: 11,
			numTotalPoints: 29,
			items: [],
			numItems: itemsCount.Writing,
			averageScore: 37.241379310344826,
			distribution: {
				basic: 18,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 11,
				none: 161,
			},
		},
		{
			id: 6485,
			label: "Output Verification",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 17,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 68,
			items: [],
			numItems: itemsCount.Speaking,
			averageScore: 0,
			distribution: {
				basic: 17,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 11,
			},
		},
		{
			id: 6486,
			label: "Practical AI Use Cases",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 10,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 0,
			items: [],
			numItems: itemsCount.Listening,
			averageScore: 0.4,
			distribution: {
				basic: 10,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 4,
			},
		},
	],
	"veterinary-medicine": [
		{
			id: 6479,
			label: "Diagnostic Reasoning",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 29,
			numIncorrect: 66,
			numSkipped: 0,
			numPointsEarned: 31,
			numTotalPoints: 101,
			items: [],
			numItems: itemsCount.Reading,
			averageScore: 30.42105263157895,
			distribution: {
				basic: 66,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 29,
				none: 45,
			},
		},
		{
			id: 6482,
			label: "Rehabilitation Planning",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 11,
			numIncorrect: 18,
			numSkipped: 0,
			numPointsEarned: 11,
			numTotalPoints: 29,
			items: [],
			numItems: itemsCount.Listening,
			averageScore: 37.241379310344826,
			distribution: {
				basic: 18,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 11,
				none: 161,
			},
		},
		{
			id: 6481,
			label: "Clinical Documentation",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 17,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 68,
			items: [],
			numItems: itemsCount.Speaking,
			averageScore: 0,
			distribution: {
				basic: 17,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 11,
			},
		},
		{
			id: 6480,
			label: "Client Communication",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 10,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 0,
			items: [],
			numItems: itemsCount.Writing,
			averageScore: 0.4,
			distribution: {
				basic: 10,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 4,
			},
		},
	],
	mcc: [
		{
			id: 7001,
			label: "Biostatistics",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 29,
			numIncorrect: 66,
			numSkipped: 0,
			numPointsEarned: 31,
			numTotalPoints: 101,
			items: [],
			numItems: itemsCount.Reading,
			averageScore: 30.42105263157895,
			distribution: {
				basic: 66,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 29,
				none: 45,
			},
		},
		{
			id: 7002,
			label: "Medicine",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 11,
			numIncorrect: 18,
			numSkipped: 0,
			numPointsEarned: 11,
			numTotalPoints: 29,
			items: [],
			numItems: itemsCount.Listening,
			averageScore: 37.241379310344826,
			distribution: {
				basic: 18,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 11,
				none: 161,
			},
		},
		{
			id: 7003,
			label: "Medical Ethics",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 17,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 68,
			items: [],
			numItems: itemsCount.Speaking,
			averageScore: 0,
			distribution: {
				basic: 17,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 11,
			},
		},
		{
			id: 7004,
			label: "Psychiatry",
			type: "Skill",
			weight: 0,
			icon: null,
			displayType: ["Display", "Filter", "Progress"],
			numCorrect: 0,
			numIncorrect: 10,
			numSkipped: 0,
			numPointsEarned: 0,
			numTotalPoints: 0,
			items: [],
			numItems: itemsCount.Writing,
			averageScore: 0.4,
			distribution: {
				basic: 10,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 4,
			},
		},
	],
} as unknown as Record<DemoExamsType, MixedItemTag[]>;

const mockedExams = {
	"healthcare-1": [
		{
			id: "1000",
			numericId: 2336,
			icon: "book-open-page-variant-outline",
			title: `${mockedTags["healthcare-1"][0].label} & ${mockedTags["healthcare-1"][1].label}`,
			numPointsEarned: 2,
			numTotalPoints: 6,
			distribution: {
				basic: 4,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 2,
				none: 0,
			},
			numItems: mockedDiagnosticStats["Reading & Listening"].numItems,
			status: "COMPLETE",
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
		},
		{
			id: "1001",
			numericId: null,
			icon: "microphone-outline",
			title: `${mockedTags["healthcare-1"][2].label} & ${mockedTags["healthcare-1"][3].label}`,
			numItems: mockedDiagnosticStats["Speaking & Writing"].numItems,
			numPointsEarned: 0,
			numTotalPoints: 0,
			status: "NOT_STARTED",
			dateCompleted: null,
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 0,
			},
		},
	],
	"construction-1": [
		{
			id: "1000",
			numericId: 2336,
			icon: "book-open-page-variant-outline",
			title: `${mockedTags["construction-1"][0].label} & ${mockedTags["construction-1"][1].label}`,
			numPointsEarned: 2,
			numTotalPoints: 6,
			distribution: {
				basic: 4,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 2,
				none: 0,
			},
			numItems: mockedDiagnosticStats["Reading & Listening"].numItems,
			status: "COMPLETE",
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
		},
		{
			id: "1001",
			numericId: null,
			icon: "microphone-outline",
			title: `${mockedTags["construction-1"][2].label} & ${mockedTags["construction-1"][3].label}`,
			numItems: mockedDiagnosticStats["Speaking & Writing"].numItems,
			numPointsEarned: 0,
			numTotalPoints: 0,
			status: "NOT_STARTED",
			dateCompleted: null,
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 0,
			},
		},
	],
	"finance-1": [
		{
			id: "1000",
			numericId: 2336,
			icon: "book-open-page-variant-outline",
			title: `${mockedTags["finance-1"][0].label} & ${mockedTags["finance-1"][1].label}`,
			numPointsEarned: 2,
			numTotalPoints: 6,
			distribution: {
				basic: 4,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 2,
				none: 0,
			},
			numItems: mockedDiagnosticStats["Reading & Listening"].numItems,
			status: "COMPLETE",
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
		},
		{
			id: "1001",
			numericId: null,
			icon: "microphone-outline",
			title: `${mockedTags["finance-1"][2].label} & ${mockedTags["finance-1"][3].label}`,
			numItems: mockedDiagnosticStats["Speaking & Writing"].numItems,
			numPointsEarned: 0,
			numTotalPoints: 0,
			status: "NOT_STARTED",
			dateCompleted: null,
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 0,
			},
		},
	],
	"officesync-1": [
		{
			id: "1000",
			numericId: 2336,
			icon: "book-open-page-variant-outline",
			title: `${mockedTags["officesync-1"][0].label} & ${mockedTags["officesync-1"][1].label}`,
			numPointsEarned: 2,
			numTotalPoints: 6,
			distribution: {
				basic: 4,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 2,
				none: 0,
			},
			numItems: mockedDiagnosticStats["Reading & Listening"].numItems,
			status: "COMPLETE",
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
		},
		{
			id: "1001",
			numericId: null,
			icon: "microphone-outline",
			title: `${mockedTags["officesync-1"][2].label} & ${mockedTags["officesync-1"][3].label}`,
			numItems: mockedDiagnosticStats["Speaking & Writing"].numItems,
			numPointsEarned: 0,
			numTotalPoints: 0,
			status: "NOT_STARTED",
			dateCompleted: null,
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 0,
			},
		},
	],
	"techcore-1": [
		{
			id: "1000",
			numericId: 2336,
			icon: "book-open-page-variant-outline",
			title: `${mockedTags["techcore-1"][0].label} & ${mockedTags["techcore-1"][1].label}`,
			numPointsEarned: 2,
			numTotalPoints: 6,
			distribution: {
				basic: 4,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 2,
				none: 0,
			},
			numItems: mockedDiagnosticStats["Reading & Listening"].numItems,
			status: "COMPLETE",
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
		},
		{
			id: "1001",
			numericId: null,
			icon: "microphone-outline",
			title: `${mockedTags["techcore-1"][2].label} & ${mockedTags["techcore-1"][3].label}`,
			numItems: mockedDiagnosticStats["Speaking & Writing"].numItems,
			numPointsEarned: 0,
			numTotalPoints: 0,
			status: "NOT_STARTED",
			dateCompleted: null,
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 0,
			},
		},
	],
	"mediquest-1": [
		{
			id: "1000",
			numericId: 2336,
			icon: "book-open-page-variant-outline",
			title: `${mockedTags["mediquest-1"][0].label} & ${mockedTags["mediquest-1"][1].label}`,
			numPointsEarned: 2,
			numTotalPoints: 6,
			distribution: {
				basic: 4,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 2,
				none: 0,
			},
			numItems: mockedDiagnosticStats["Reading & Listening"].numItems,
			status: "COMPLETE",
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
		},
		{
			id: "1001",
			numericId: null,
			icon: "microphone-outline",
			title: `${mockedTags["mediquest-1"][2].label} & ${mockedTags["mediquest-1"][3].label}`,
			numItems: mockedDiagnosticStats["Speaking & Writing"].numItems,
			numPointsEarned: 0,
			numTotalPoints: 0,
			status: "NOT_STARTED",
			dateCompleted: null,
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 0,
			},
		},
	],
	"aswb-1": [
		{
			id: "1000",
			numericId: 2336,
			icon: "book-open-page-variant-outline",
			title: `${mockedTags["aswb-1"][0].label} & ${mockedTags["aswb-1"][1].label}`,
			numPointsEarned: 2,
			numTotalPoints: 6,
			distribution: {
				basic: 4,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 2,
				none: 0,
			},
			numItems: mockedDiagnosticStats["Reading & Listening"].numItems,
			status: "COMPLETE",
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
		},
		{
			id: "1001",
			numericId: null,
			icon: "microphone-outline",
			title: `${mockedTags["aswb-1"][2].label} & ${mockedTags["aswb-1"][3].label}`,
			numItems: mockedDiagnosticStats["Speaking & Writing"].numItems,
			numPointsEarned: 0,
			numTotalPoints: 0,
			status: "NOT_STARTED",
			dateCompleted: null,
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 0,
			},
		},
	],
	"aswb-supervision-certification": [
		{
			id: "1000",
			numericId: 2336,
			icon: "book-open-page-variant-outline",
			title: `${mockedTags["aswb-supervision-certification"][0].label} & ${mockedTags["aswb-supervision-certification"][1].label}`,
			numPointsEarned: 2,
			numTotalPoints: 6,
			distribution: {
				basic: 4,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 2,
				none: 0,
			},
			numItems: mockedDiagnosticStats["Reading & Listening"].numItems,
			status: "COMPLETE",
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
		},
		{
			id: "1001",
			numericId: null,
			icon: "microphone-outline",
			title: `${mockedTags["aswb-supervision-certification"][2].label} & ${mockedTags["aswb-supervision-certification"][3].label}`,
			numItems: mockedDiagnosticStats["Speaking & Writing"].numItems,
			numPointsEarned: 0,
			numTotalPoints: 0,
			status: "NOT_STARTED",
			dateCompleted: null,
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 0,
			},
		},
	],
	"ai-assessment": [
		{
			id: "1000",
			numericId: 2336,
			icon: "book-open-page-variant-outline",
			title: `${mockedTags["ai-assessment"][0].label} & ${mockedTags["ai-assessment"][1].label}`,
			numPointsEarned: 2,
			numTotalPoints: 6,
			distribution: {
				basic: 4,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 2,
				none: 0,
			},
			numItems: mockedDiagnosticStats["Reading & Listening"].numItems,
			status: "COMPLETE",
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
		},
		{
			id: "1001",
			numericId: null,
			icon: "microphone-outline",
			title: `${mockedTags["ai-assessment"][2].label} & ${mockedTags["ai-assessment"][3].label}`,
			numItems: mockedDiagnosticStats["Speaking & Writing"].numItems,
			numPointsEarned: 0,
			numTotalPoints: 0,
			status: "NOT_STARTED",
			dateCompleted: null,
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 0,
			},
		},
	],
	"genai-engineer": [
		{
			id: "1000",
			numericId: 2336,
			icon: "book-open-page-variant-outline",
			title: `${mockedTags["genai-engineer"][0].label} & ${mockedTags["genai-engineer"][1].label}`,
			numPointsEarned: 2,
			numTotalPoints: 6,
			distribution: {
				basic: 4,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 2,
				none: 0,
			},
			numItems: mockedDiagnosticStats["Reading & Listening"].numItems,
			status: "COMPLETE",
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
		},
		{
			id: "1001",
			numericId: null,
			icon: "microphone-outline",
			title: `${mockedTags["genai-engineer"][2].label} & ${mockedTags["genai-engineer"][3].label}`,
			numItems: mockedDiagnosticStats["Speaking & Writing"].numItems,
			numPointsEarned: 0,
			numTotalPoints: 0,
			status: "NOT_STARTED",
			dateCompleted: null,
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 0,
			},
		},
	],
	"ai-essentials": [
		{
			id: "1000",
			numericId: 2336,
			icon: "book-open-page-variant-outline",
			title: `${mockedTags["ai-essentials"][0].label} & ${mockedTags["ai-essentials"][1].label}`,
			numPointsEarned: 2,
			numTotalPoints: 6,
			distribution: {
				basic: 4,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 2,
				none: 0,
			},
			numItems: mockedDiagnosticStats["Reading & Listening"].numItems,
			status: "COMPLETE",
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
		},
		{
			id: "1001",
			numericId: null,
			icon: "microphone-outline",
			title: `${mockedTags["ai-essentials"][2].label} & ${mockedTags["ai-essentials"][3].label}`,
			numItems: mockedDiagnosticStats["Speaking & Writing"].numItems,
			numPointsEarned: 0,
			numTotalPoints: 0,
			status: "NOT_STARTED",
			dateCompleted: null,
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 0,
			},
		},
	],
	"veterinary-medicine": [
		{
			id: "1000",
			numericId: 2336,
			icon: "book-open-page-variant-outline",
			title: `${mockedTags["veterinary-medicine"][0].label} & ${mockedTags["veterinary-medicine"][1].label}`,
			numPointsEarned: 2,
			numTotalPoints: 6,
			distribution: {
				basic: 4,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 2,
				none: 0,
			},
			numItems: mockedDiagnosticStats["Reading & Listening"].numItems,
			status: "COMPLETE",
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
		},
		{
			id: "1001",
			numericId: null,
			icon: "microphone-outline",
			title: `${mockedTags["veterinary-medicine"][2].label} & ${mockedTags["veterinary-medicine"][3].label}`,
			numItems: mockedDiagnosticStats["Speaking & Writing"].numItems,
			numPointsEarned: 0,
			numTotalPoints: 0,
			status: "NOT_STARTED",
			dateCompleted: null,
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 0,
			},
		},
	],
	mcc: [
		{
			id: "1000",
			numericId: 2336,
			icon: "book-open-page-variant-outline",
			title: `${mockedTags.mcc[0].label} & ${mockedTags.mcc[1].label}`,
			numPointsEarned: 2,
			numTotalPoints: 6,
			distribution: {
				basic: 4,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 2,
				none: 0,
			},
			numItems: mockedDiagnosticStats["Reading & Listening"].numItems,
			status: "COMPLETE",
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
		},
		{
			id: "1001",
			numericId: null,
			icon: "microphone-outline",
			title: `${mockedTags.mcc[2].label} & ${mockedTags.mcc[3].label}`,
			numItems: mockedDiagnosticStats["Speaking & Writing"].numItems,
			numPointsEarned: 0,
			numTotalPoints: 0,
			status: "NOT_STARTED",
			dateCompleted: null,
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 0,
			},
		},
	],
	proethica: [
		{
			id: "1007",
			numericId: 7001,
			icon: "school-outline",
			title: "Module 7",
			numPointsEarned: 9,
			numTotalPoints: 10,
			distribution: {
				basic: 0,
				lowIntermediate: 1,
				highIntermediate: 0,
				advanced: 9,
				none: 0,
			},
			numItems: 10,
			status: "COMPLETE",
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
		},
		{
			id: "1003",
			numericId: null,
			icon: "school-outline",
			title: "Module 3",
			numPointsEarned: 0,
			numTotalPoints: 0,
			distribution: {
				basic: 0,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 0,
				none: 10,
			},
			numItems: 10,
			status: "NOT_STARTED",
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
		},
		{
			id: "1004",
			numericId: 4001,
			icon: "school-outline",
			title: "Module 4",
			numPointsEarned: 4,
			numTotalPoints: 10,
			distribution: {
				basic: 2,
				lowIntermediate: 2,
				highIntermediate: 0,
				advanced: 0,
				none: 6,
			},
			numItems: 10,
			status: "ACTIVE",
			type: "SUMMATIVE",
			subType: "DIAGNOSTIC",
		},
	],
};
export const mockedMixedItemDistribution = (demoExamId: DemoExamsType) => ({
	contents: [
		{
			id: 38,
			distribution: {
				basic: 111,
				lowIntermediate: 0,
				highIntermediate: 0,
				advanced: 40,
				none: 221,
			},
			totalCount: 372,
		},
	],
	accuracy: 26.49,
	speed: "14.92",
	tags: mockedTags[demoExamId],
	numPointsEarned: 42,
	numTotalPoints: 455,
	exams: mockedExams[demoExamId],
});
